import { useEffect } from 'react';
import _ from 'lodash';
import { useObserver } from 'mobx-react-lite';
import { useQuery } from '@apollo/client';
import { useHistory, useParams } from 'react-router-dom';

import { adminDispensaries } from 'shared/graphql/dispensary/queries';
import { useStores } from 'src/hooks/use-stores';
import { useGetDegradedPollInterval } from 'shared/hooks/use-get-degraded-poll-interval';

export default function useLoadDispensary() {
  const { apolloClient, UI } = useStores();
  const history = useHistory();
  const { id } = useParams();
  const dispensaryId = useObserver(() => UI.dispensary?.id);
  const pollInterval = useGetDegradedPollInterval({ milliseconds: 60000, increasePollInterval: 10 });

  const { data, error, networkStatus, loading } = useQuery(adminDispensaries, {
    client: apolloClient,
    fetchPolicy: 'network-only',
    pollInterval,
    variables: {
      dispensaryFilter: {
        cNameOrID: id,
        includePending: true,
      },
    },
  });

  useEffect(() => {
    if (error) {
      console.error('Could not locate dispensary');
      console.error(error);
      history.replace('/redirect');
    }
  }, [error, history]);

  const dispensary = _.get(data, 'filteredDispensaries[0]', null);

  useEffect(() => {
    if (dispensary) {
      UI.setDispensary(dispensary);
    }
  }, [dispensary, UI, history]);

  useEffect(
    () => () => {
      UI.unsetDispensary();
    },
    [UI]
  );

  return { networkStatus, dispensaryId, loading };
}
